import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "./assets/scss/material-kit-react.css";
import Components from "./views/Components/Components.jsx";
import GenericPage from "./views/GenericPage/GenericPage.jsx";
import Publications from "./views/Publications/Publications.jsx";
import DigitalMaps from "./views/Publications/DigitalMaps.jsx";
import AboutUs from "./views/About Us/AboutUs.jsx";
import HttpsRedirect from "react-https-redirect";
import Loading from "./components/Loading/Loading";
import getFileData from "./APICall/Api";

window.language = {
  setLanguage(lang) {
    if (typeof lang === "undefined") return window.language.default;
    else if (typeof window.language[lang] !== "undefined")
      return window.language[lang];
  },

  goTo(match, _lang) {
    if (typeof match !== "undefined") {
      if (typeof match.params.lang !== "undefined")
        return match.url.replace(`/${match.params.lang}`, `/${_lang}`);
      else return `/${_lang}${match.url}`;
    }
  },

  currUrl(match, next) {
    if (typeof match.params.lang === "undefined")
      return `${window.language.default.lang}/${next}`;
    else return `/${match.params.lang}/${next}`;
  }
};

// eslint-disable-next-line
Array.prototype.chunk = function (n) {
  if (!this.length) {
    return [];
  }
  return [this.slice(0, n)].concat(this.slice(n).chunk(n));
};

// eslint-disable-next-line
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};



class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEngLoaded: false,
      isAlbLoaded: false,
      language: {},
      error: null,
      url: getFileData
    };
  }
  componentDidMount() {
    this.callAPI("eng", { isEngLoaded: true })
    this.callAPI("alb", { isAlbLoaded: true })
  }

  componentWillReceiveProps(newProps) {
  }

  callAPI = async (lang, update) => {
    fetch(`${this.state.url.getFileData}/App${lang.capitalize()}.json`,
      { method: 'get', headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }) }
    )
      .then(res => res.json())
      .then(
        (result) => {
          window.language = {
            ...window.language,
            [lang]: result.app
          };
          if (lang === "eng") {
            window.language.default = result.app;
            this.setState({ language: result.app })
          }
          this.setState(update);
        },
        (error) => {
          this.setState(update);
          this.setState({
            error: error
          });
        }
      )
  }

  render() {

    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (this.state.isEngLoaded && this.state.isAlbLoaded) {
      return (
        <BrowserRouter>
          <Switch>
            <Route exact path="/:lang?" component={Components} />
            <Route exact path="/:lang/aboutus" component={AboutUs} />
            <Route exact path="/:lang/publications" component={Publications} />
            <Route exact path="/:lang/digital-map" component={DigitalMaps} />
            <Route
              exact
              path="/:lang/:component(projects|trainings|events)"
              component={GenericPage}
            />
          </Switch>
        </BrowserRouter >
      );
    } else {
      return <Loading />;
    }
  }
}
export default withRouter(App);

ReactDOM.render(
  <HttpsRedirect>
    <App />
  </HttpsRedirect>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js